import type { GlobalSearchHit } from '@/api/endpoints/search';
import { canAccessRoute } from '@/lib/permissions';

/** Dummy path segment — `canAccessRoute` matches on prefix only. */
const SAMPLE_ID = '1';

/**
 * Whether the signed-in role may open a global-search hit's detail route (DEF-265).
 *
 * Limited User is list-only for properties; User/Limited User have no Reports module.
 * Orders remain clickable for every role that can reach `/search`.
 */
export function canOpenGlobalSearchHit(role: string | undefined, hit: GlobalSearchHit): boolean {
  if (!role) return false;

  switch (hit.type) {
    case 'building':
      return canAccessRoute(role, `/properties/${SAMPLE_ID}`);
    case 'report':
      return canAccessRoute(role, `/reports/${SAMPLE_ID}`);
    case 'request':
      return canAccessRoute(role, `/orders/${SAMPLE_ID}`);
    case 'vault':
      return canAccessRoute(role, `/drawing-vault/${SAMPLE_ID}`);
    default:
      return false;
  }
}
